import { AmberHoc, AmberHocProps } from '../../../util';
import {
  BargeCoverPelletLinkFragmentFragment as Result,
  GetBargeCoverPelletLinksDocument,
  GetBargeCoverPelletLinksQuery,
  GetBargeCoverPelletLinksQueryVariables,
  UnlinkBargeCoverPelletMutationVariables as Variables,
  withUnlinkBargeCoverPellet as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

// TODO: Modify return results to include barge id, and remove it from the parent props;
export type WithUnlinkBargeCoverPelletHocOwnProps = {
  barge_id: number;
};
export type WithUnlinkBargeCoverPelletHocChildProps = {
  unlinkBargeCoverPellet: (variables: Variables) => Promise<Result[]>;
};
export const withUnlinkBargeCoverPelletHoc: AmberHoc<
  WithUnlinkBargeCoverPelletHocOwnProps,
  WithUnlinkBargeCoverPelletHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<
      WithUnlinkBargeCoverPelletHocOwnProps,
      WithUnlinkBargeCoverPelletHocChildProps,
      typeof component
    >,
    WithUnlinkBargeCoverPelletHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const {
        mutate,
        ownProps: { barge_id },
      } = props;
      return {
        unlinkBargeCoverPellet: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors: errors2 }) => {
              if (errors2 || !data) {
                return;
              }
              const { unlinkBargeCoverPellet: result } = data;
              proxy.writeQuery<
                GetBargeCoverPelletLinksQuery,
                GetBargeCoverPelletLinksQueryVariables
              >({
                query: GetBargeCoverPelletLinksDocument,
                data: { __typename: 'Query', barge_cover_pellet_links: result },
                variables: { barge_id },
              });
            },
          });
          if (!result) {
            throw new Error('Unexpected response from server');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.unlinkBargeCoverPellet) {
            throw new Error('Unexpected response from server');
          }
          return data.unlinkBargeCoverPellet;
        },
      };
    },
  })(component as any);
